module.exports = __webpack_public_path__ + "static/media/video.120a3248.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/video.webm
// module id = 224
// module chunks = 0